import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Pencil } from '../../../icons/pencil';
import STRING_KEYS from '../../../language/keys';
import { style } from './style';

type ChangeCompanyButtonProps = {
  onCompanyChangeClick: () => void,
}

export const ChangeCompanyButton = ({
  onCompanyChangeClick,
}: ChangeCompanyButtonProps):JSX.Element => {
  const { t: translate } = useTranslation();
  
  return (
    <Button
      onClick={ onCompanyChangeClick }
      startIcon={ (
        <Pencil sx={ style.icon.sx } />
      ) }
    >
      {translate(STRING_KEYS.CHANGE)}
    </Button>
  );
};
